var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WalletConnect"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 72",
    width: 96,
    height: 96,
    rx: 10,
    fill: "#3396FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "WalletConnect-icon 1",
    clipPath: "url(#clip0_122_870)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WalletConnect_00000073703063438220642730000002917717552236472496_",
    d: "M26.9249 34.9488C38.3638 23.7905 56.9158 23.7905 68.3547 34.9488L69.7303 36.2828C70.3095 36.8416 70.3095 37.7429 69.7303 38.3018L65.0244 42.8985C64.7348 43.1689 64.2823 43.1689 63.9927 42.8985L62.0923 41.0418C54.1104 33.2544 41.1692 33.2544 33.1873 41.0418L31.1602 43.0247C30.8706 43.2951 30.4181 43.2951 30.1285 43.0247L25.4045 38.446C24.8253 37.8872 24.8253 36.9858 25.4045 36.427L26.9249 34.9488ZM78.0923 44.4488L82.2914 48.5408C82.8706 49.0996 82.8706 50.0009 82.2914 50.5597L63.3774 69.0007C62.7982 69.5596 61.8751 69.5596 61.314 69.0007L47.9022 55.9136C47.7575 55.7694 47.5222 55.7694 47.3774 55.9136L33.9656 69.0007C33.3864 69.5596 32.4633 69.5596 31.9022 69.0007L12.9882 50.5597C12.409 50.0009 12.409 49.0996 12.9882 48.5408L17.1873 44.4488C17.7665 43.8899 18.6896 43.8899 19.2507 44.4488L32.6624 57.5359C32.8072 57.6802 33.0425 57.6802 33.1873 57.5359L46.5991 44.4488C47.1783 43.8899 48.1013 43.8899 48.6624 44.4488L62.0742 57.5359C62.219 57.6802 62.4543 57.6802 62.5991 57.5359L76.0108 44.4488C76.59 43.8899 77.5131 43.8899 78.0923 44.4488Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.1538,
    height: 42.8308,
    fill: "white",
    transform: "translate(12.5538 26.5847)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.a0f83825407afe98cefbaab0a73cd117.svg";
export { ForwardRef as ReactComponent };